type SlackDmInfo = { readonly integration: 'slack'; readonly openDmUrl: string };
type MsTeamsDmInfo = { readonly integration: 'ms-teams'; readonly openDmUrl: string };
export type ExternalMessageDmIntegrationInfo = SlackDmInfo | MsTeamsDmInfo;

type UserWithMaybeDmInfo = {
	email?: string | null;
	externalId?: string | null;
};
/**
 * @returns information for the feature to Direct Message the user
 */
export const getExternalMessageDmIntegrationInfo: (
	integrationId?: string | null,
	user?: UserWithMaybeDmInfo,
) => ExternalMessageDmIntegrationInfo | undefined = (
	integrationId?: string | null,
	user?: UserWithMaybeDmInfo,
): ExternalMessageDmIntegrationInfo | undefined => {
	if (!integrationId || !user) {
		return;
	}

	const isSlack = integrationId === 'slack';
	const isMsTeams = integrationId === 'microsoft';

	if (isSlack) {
		const openDmUrl = getOpenInSlackUrl(user);
		if (openDmUrl) {
			return { integration: 'slack', openDmUrl };
		}
	} else if (isMsTeams) {
		const openDmUrl = getOpenInTeamsUrl(user);
		if (openDmUrl) {
			return { integration: 'ms-teams', openDmUrl };
		}
	}
};

/**
 * @returns Open in Slack URL for the user
 */
export const getOpenInSlackUrl: (user?: UserWithMaybeDmInfo) => string | undefined = (
	user?: UserWithMaybeDmInfo,
) => {
	const externalId = user?.externalId;
	if (!externalId) {
		return;
	}
	return `https://slack.com/app_redirect?channel=${externalId}`;
};

/**
 * @returns Open in MS Teams URL for the user
 */
export const getOpenInTeamsUrl: (user?: UserWithMaybeDmInfo) => string | undefined = (
	user?: UserWithMaybeDmInfo,
) => {
	const email = user?.email;
	if (!email) {
		return;
	}
	return `https://teams.microsoft.com/l/chat/0/0?users=${email}`;
};
